import React from "react";
import { Container, Typography, Box, AppBar, Toolbar } from "@mui/material";

const TermsAndConditions = () => {
  return (
    <Box>
      {/* Header */}
      <AppBar position="static" color="primary">
        <Toolbar sx={{ justifyContent: "center" }}>
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <img
              src="/logo192.png"
              alt="BGIC Logo"
              style={{ height: 50, marginRight: 16 }}
            />
            <Typography variant="h6" component="div" fontWeight={600}>
              BGIC Digital Store
            </Typography>
          </a>
        </Toolbar>
      </AppBar>

      {/* Content */}
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Typography variant="h4" gutterBottom fontWeight={600}>
          Terms & Conditions
        </Typography>

        <Typography variant="body2" color="textSecondary" gutterBottom>
          Last updated: [Date]
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Effective: Upon publication
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Typography variant="body1" paragraph>
            Welcome to <strong>https://www.bgicdigital.com/</strong> (“Site”). By using this Site and our digital services, you agree to the following Terms & Conditions.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>1. Acceptance:</strong> By accessing and using this Site, you confirm that you have read, understood, and agreed to these Terms.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>2. Scope of Services:</strong> BGIC provides general insurance products and related digital services (policy purchase, premium payment) through this portal.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>3. User Responsibilities:</strong> You agree to:
            <ul>
              <li>Provide accurate and complete personal information</li>
              <li>Use the Site lawfully and responsibly</li>
              <li>Not misuse or attempt to disrupt Site operations</li>
            </ul>
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>4. Payments:</strong>
            <ul>
              <li>All payments through this Site use SSLCommerz</li>
              <li>You are responsible for providing valid payment information</li>
              <li>Transaction confirmation is subject to payment gateway approval</li>
            </ul>
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>5. Intellectual Property:</strong> All content on this Site, including text, graphics, logos, and code, is the property of BGIC or its licensors and is protected by law.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>6. Limitation of Liability:</strong> BGIC is not liable for:
            <ul>
              <li>Indirect, incidental, special, or consequential damages</li>
              <li>Losses due to interruptions, delays, or system errors</li>
              <li>Disputes arising from third-party services (e.g., banking, payment gateways)</li>
            </ul>
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>7. Termination:</strong> BGIC may suspend or terminate access to the Site at any time for violations of these Terms or for maintenance.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>8. Governing Law:</strong> These Terms are governed by the laws of Bangladesh.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>9. Contact:</strong><br />
            📧 Email: info@bgicinsure.com / bgicinsurance@gmail.com<br />
            📍 Address: 42, Dilkusha C/A, Dhaka-1000, Bangladesh
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
